<template>
  <v-btn
    class="button button--primary button--toolbar button--full-mobile toolbar-action-button"
    :disabled="disabled"
    :loading="loading"
    :prepend-icon="icon"
    :to="to"
    :type="type"
    variant="flat"
    @click="emitClick"
  >
    <slot>{{ text }}</slot>
  </v-btn>
</template>

<script setup>
defineProps({
  text: {
    type: String,
    default: '',
  },

  icon: {
    type: String,
    default: 'mdi-plus',
  },

  to: {
    type: [String, Object],
    default: null,
  },

  type: {
    type: String,
    default: 'button',
  },

  disabled: {
    type: Boolean,
    default: false,
  },

  loading: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['click'])

function emitClick (event) {
  emit('click', event)
}
</script>
